/**
 * @file Contains hook for generating actions array for open compose button
 */
import { useLocation } from 'react-router-dom';

import { ComposeNodeType } from '../../../containers/compose/props';
import useParamTemplateId from '../../../hooks/router/params/useParamTemplateId';
import { getOpenComposeUrl } from '../../../routes/urls/searchParams/compose';
import { MuiIconName } from '../../MUI/MuiIcon/types';

import { getComposeActionLabel } from './helpers';

type ComposeAction = {
  icon: MuiIconName;
  label: string;
  url: string;
};

/**
 * Hook for generating actions array for open compose button
 *
 * @param nodeType Type of node (MESSAGE or TEMPLATE)
 *
 * @returns        Array of actions
 */
const useComposeActions = (nodeType: ComposeNodeType): ComposeAction[] => {
  const location = useLocation();
  const nodeId = useParamTemplateId();

  return [
    {
      icon: 'task',
      label: getComposeActionLabel('task', nodeType),
      url: getOpenComposeUrl(location, 'task').replace('/' + nodeId, ''),
    },
    {
      icon: 'post',
      label: getComposeActionLabel('post', nodeType),
      url: getOpenComposeUrl(location, 'post').replace('/' + nodeId, ''),
    },
  ];
};

export default useComposeActions;
